"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var Cookies = __importStar(require("js-cookie"));
var compact_1 = __importDefault(require("lodash/compact"));
var flatten_1 = __importDefault(require("lodash/flatten"));
var pick_1 = __importDefault(require("lodash/pick"));
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var crumb_nav_1 = __importDefault(require("../../account-v3/components/crumb_nav"));
var inline_loader_1 = __importDefault(require("../../account-v3/components/inline_loader"));
var quantity_selector_1 = __importDefault(require("../../cart/quantity-selector"));
var magic_link_1 = require("../../magic-link");
var api_1 = require("../api");
var app_1 = require("../app");
var getEligibleOrders_1 = require("../queries/getEligibleOrders");
var date_fns_1 = require("date-fns");
exports.default = (function (_a) {
    var basePath = _a.basePath;
    var isCS = !!Cookies.get(magic_link_1.SUBLESS_JWT_COOKIE_NAME);
    var context = (0, react_1.useContext)(app_1.NewReturnContext);
    if (!context)
        return null;
    var setSelectedItems = context.setSelectedItems, selectedItems = context.selectedItems, csNumDays = context.csNumDays, setCsNumDays = context.setCsNumDays;
    var _b = (0, react_query_1.useQuery)([app_1.QueryKey.ELIGIBLE_RETURN_ORDERS, { csNumDays: csNumDays }], function () {
        return (0, api_1.getSublessAPIClient)().request(getEligibleOrders_1.GET_ELIGIBLE_ORDERS, {
            startDate: (0, date_fns_1.format)((0, date_fns_1.subDays)(new Date(), csNumDays + 60), 'yyyy-MM-dd'),
            endDate: (0, date_fns_1.format)((0, date_fns_1.subDays)(new Date(), csNumDays), 'yyyy-MM-dd'),
        });
    }, {
        cacheTime: Infinity,
        staleTime: Infinity,
        refetchOnMount: true,
    }), data = _b.data, isLoading = _b.isLoading;
    var orders = data === null || data === void 0 ? void 0 : data.account.eligibleReturnOrders;
    var history = (0, react_router_dom_1.useHistory)();
    if (!context)
        return null;
    var addItems = function (items) {
        var newItems = (0, uniqBy_1.default)((0, flatten_1.default)(selectedItems.concat(items)), function (i) {
            return { orderId: i.orderId, lineItemId: i.lineItemId };
        });
        setSelectedItems(newItems);
    };
    var removeItems = function (lineItemIds) {
        setSelectedItems(selectedItems.filter(function (i) { return !lineItemIds.includes(i.lineItemId); }));
    };
    var selectOrder = function (orderId) {
        var order = orders === null || orders === void 0 ? void 0 : orders.find(function (o) { return o.shopifyOrderId === orderId; });
        if (!order)
            return;
        var orderItems = order.lineItems.map(function (li) {
            var refundPrice = ((Number(li.refundUnitPrice) * 100 * li.quantity) / 100).toFixed(2);
            return { orderId: orderId, lineItemId: li.id, quantity: li.quantity, imageSrc: li.imageSrc, title: li.title, refundUnitPrice: li.refundUnitPrice, refundPrice: refundPrice, variant: li.variant };
        });
        addItems(orderItems);
    };
    var unselectOrder = function (orderId) {
        var order = orders === null || orders === void 0 ? void 0 : orders.find(function (o) { return o.shopifyOrderId === orderId; });
        if (!order)
            return;
        removeItems(order.lineItems.map(function (li) { return li.id; }));
    };
    var selectItem = function (orderId, lineItemId) {
        var order = orders === null || orders === void 0 ? void 0 : orders.find(function (o) { return o.shopifyOrderId === orderId; });
        var lineItem = order === null || order === void 0 ? void 0 : order.lineItems.find(function (l) { return l.id === lineItemId; });
        if (!lineItem)
            return;
        var refundPrice = ((Number(lineItem.refundUnitPrice) * 100 * lineItem.quantity) / 100).toFixed(2);
        var item = Object.assign((0, pick_1.default)(lineItem, ['quantity', 'imageSrc', 'refundUnitPrice', 'title', 'variant']), {
            orderId: orderId,
            lineItemId: lineItemId,
            refundPrice: refundPrice,
        });
        console.debug("Calling additems", item);
        addItems([item]);
    };
    var isItemSelected = function (lineItemId) { return selectedItems.some(function (i) { return i.lineItemId === lineItemId; }); };
    var orderLevelAction = function (orderId) {
        var order = orders === null || orders === void 0 ? void 0 : orders.find(function (o) { return o.shopifyOrderId === orderId; });
        if (!order)
            return null;
        var numSelected = selectedItems.filter(function (i) { return i.orderId === orderId; }).length;
        if (numSelected === 0)
            return (react_1.default.createElement("a", { onClick: function () { return selectOrder(order.shopifyOrderId); } },
                react_1.default.createElement("img", { src: window.returnsApp.iconUrls.checkboxEmpty })));
        if (numSelected < order.lineItems.length)
            return (react_1.default.createElement("a", { onClick: function () { return selectOrder(order.shopifyOrderId); } },
                react_1.default.createElement("img", { src: window.returnsApp.iconUrls.checkboxHalf })));
        return (react_1.default.createElement("a", { onClick: function () { return unselectOrder(order.shopifyOrderId); } },
            react_1.default.createElement("img", { src: window.returnsApp.iconUrls.checkboxChecked })));
    };
    var changeQuantity = function (lineItemId, change) {
        var e_1, _a;
        if (!orders)
            return;
        var maxQuantity = 0;
        try {
            for (var orders_1 = __values(orders), orders_1_1 = orders_1.next(); !orders_1_1.done; orders_1_1 = orders_1.next()) {
                var order = orders_1_1.value;
                var li = order.lineItems.find(function (l) { return l.id === lineItemId; });
                if (li)
                    maxQuantity = li.quantity;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (orders_1_1 && !orders_1_1.done && (_a = orders_1.return)) _a.call(orders_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var newItems = (0, compact_1.default)(selectedItems.map(function (i) {
            if (i.lineItemId === lineItemId) {
                var newQuantity = i.quantity + change;
                if (newQuantity === 0)
                    return;
                if (newQuantity > maxQuantity)
                    newQuantity = maxQuantity;
                if (newQuantity <= 0)
                    newQuantity = 1;
                var refundPrice = (Number(i.refundUnitPrice) * 100 * newQuantity * 100).toFixed(2);
                return Object.assign(i, { quantity: newQuantity, refundPrice: refundPrice });
            }
            else
                return i;
        }));
        setSelectedItems(newItems);
    };
    return (react_1.default.createElement("div", { className: 'padding-bottom-3 return-container' },
        react_1.default.createElement(crumb_nav_1.default, { current: 'Returns' }),
        react_1.default.createElement("div", { className: 'padding-top-10 padding-bottom-5 account-header' }, window.returnsApp.copy.startReturnStepHeader),
        react_1.default.createElement("div", { className: 'padding-left-4 padding-right-4' },
            react_1.default.createElement("div", { className: 'margin-bottom-4 font-lighter font-size-small links-wisteria', dangerouslySetInnerHTML: { __html: window.returnsApp.copy.startReturnStepCopy } }),
            isCS && (react_1.default.createElement("div", null,
                react_1.default.createElement("label", null, "CS Only: Date Range"),
                react_1.default.createElement("select", { placeholder: 'Number of days to look back', onChange: function (event) { return setCsNumDays(Number(event.currentTarget.value)); }, value: csNumDays }, [0, 60, 120, 180, 240].map(function (num) { return (react_1.default.createElement("option", { key: num, value: num },
                    (0, date_fns_1.format)((0, date_fns_1.subDays)(new Date(), num), 'MM/dd/yyyy'),
                    " - ",
                    (0, date_fns_1.format)((0, date_fns_1.subDays)(new Date(), num + 60), 'MM/dd/yyyy'))); })))),
            react_1.default.createElement(inline_loader_1.default, { isLoading: isLoading }),
            !isLoading && (orders === null || orders === void 0 ? void 0 : orders.length) === 0 && (react_1.default.createElement("div", { className: 'padding-4 margin-top-4 bg-very-light-pink text-center margin-bottom-4 font-size-small' }, "There are no orders eligible for return")),
            orders && (react_1.default.createElement("div", null, orders.map(function (order) { return (react_1.default.createElement("div", { key: order.shopifyOrderId, className: 'account-return-panel' },
                react_1.default.createElement("h6", null,
                    react_1.default.createElement("span", { className: 'margin-right-4' }, orderLevelAction(order.shopifyOrderId)),
                    "Order ",
                    order.orderNumber),
                react_1.default.createElement("p", { className: 'font-size-small font-lighter margin-bottom-4' },
                    "Placed on: ",
                    (0, date_fns_1.format)(new Date(order.createdAt), 'MM/dd/yyyy')),
                order.lineItems.map(function (lineItem) {
                    var _a, _b, _c;
                    return (react_1.default.createElement("div", { key: lineItem.id, className: 'media-object margin-bottom-6 padding-left-4' },
                        react_1.default.createElement("div", { className: 'media-object-section align-self-top' },
                            isItemSelected(lineItem.id) ? (react_1.default.createElement("a", { onClick: function () { return removeItems([lineItem.id]); }, style: { verticalAlign: 'top' } },
                                react_1.default.createElement("img", { src: window.returnsApp.iconUrls.checkboxChecked }))) : (react_1.default.createElement("a", { onClick: function () { return selectItem(order.shopifyOrderId, lineItem.id); }, style: { verticalAlign: 'top' } },
                                react_1.default.createElement("img", { src: window.returnsApp.iconUrls.checkboxEmpty }))),
                            react_1.default.createElement("div", { className: 'return-item-img-container margin-left-4 margin-right-3' }, lineItem.imageSrc && react_1.default.createElement("img", { src: lineItem.variant.imgSrc || ((_a = lineItem.variant.product) === null || _a === void 0 ? void 0 : _a.imgSrc) }))),
                        react_1.default.createElement("div", { className: 'media-object-section main-section align-self-top font-size-small font-lighter' },
                            react_1.default.createElement("p", null,
                                ((_b = lineItem.variant.product) === null || _b === void 0 ? void 0 : _b.title) || lineItem.variant.title,
                                lineItem.variant.option1 && (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement("br", null),
                                    react_1.default.createElement("span", { className: 'text-brownish-grey' },
                                        lineItem.variant.option1,
                                        " ",
                                        lineItem.variant.option2 ? " / ".concat(lineItem.variant.option2) : ''))))),
                        react_1.default.createElement("div", { className: 'media-object-section align-self-top' }, isItemSelected(lineItem.id) && (react_1.default.createElement(quantity_selector_1.default, { quantity: ((_c = selectedItems.find(function (i) { return i.lineItemId === lineItem.id; })) === null || _c === void 0 ? void 0 : _c.quantity) || 0, increase: function () { return changeQuantity(lineItem.id, 1); }, decrease: function () { return changeQuantity(lineItem.id, -1); } })))));
                }),
                react_1.default.createElement("div", null))); }))),
            !isLoading && (react_1.default.createElement("div", { className: 'checkout-cta-container' },
                react_1.default.createElement("button", { className: (0, classnames_1.default)({ 'button btn-form': true, 'is-disabled': selectedItems.length === 0 }), type: 'button', disabled: selectedItems.length === 0, onClick: function () { return history.push("".concat(basePath, "/reasons")); } }, "Continue"))))));
});
